import http from "../http-common";

class CleaningScheduleService {
  getWeek(params) {
    return http.get("/cleaning-schedule/week", { params });
  }

  createTrack(data) {
    return http.post("/cleaning-schedule/tracks", data);
  }

  previewRecurringConflicts(data) {
    return http.post("/cleaning-schedule/tracks/preview-recurring-conflicts", data);
  }

  deleteTrack(id) {
    return http.delete(`/cleaning-schedule/tracks/${id}`);
  }

  getWeeklyAvailability(params) {
    return http.get("/cleaning-schedule/availability/weekly", { params });
  }

  putWeeklyAvailability(data) {
    return http.put("/cleaning-schedule/availability/weekly", data);
  }

  getUnavailability(params) {
    return http.get("/cleaning-schedule/availability/unavailability", { params });
  }

  postUnavailability(data) {
    return http.post("/cleaning-schedule/availability/unavailability", data);
  }

  deleteUnavailability(id) {
    return http.delete(`/cleaning-schedule/availability/unavailability/${id}`);
  }
}

export default new CleaningScheduleService();
